var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    {
      attrs: {
        value: !_vm.isOnline,
        type: "warning",
        icon: _vm.SbIcons.status.noConnection
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.offlineMessage) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }